import { jsx } from "react/jsx-runtime";
import { forwardRef, Children } from "react";
import PropTypes from "prop-types";
import { InlineWrapper, InlineItem } from "./inline.styles.es.js";
import { deprecated } from "../../../prop-types-validators/deprecated.es.js";
const propTypes = {
  align: PropTypes.oneOf(["start", "center", "end"]),
  alignX: PropTypes.oneOf(["center", "left", "right"]),
  alignY: PropTypes.oneOf(["bottom", "center", "top"]),
  as: PropTypes.elementType,
  children: PropTypes.node,
  justify: PropTypes.oneOf([
    "center",
    "end",
    "space-around",
    "space-between",
    "space-evenly",
    "start"
  ]),
  noWrap: PropTypes.bool,
  space: PropTypes.oneOf([
    "none",
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge"
  ]).isRequired,
  spacing: deprecated(
    PropTypes.oneOf(["none", "small", "medium", "large", "xlarge"]),
    "Use space prop instead."
  )
};
const defaultProps = {
  align: void 0,
  alignX: "left",
  alignY: "top",
  as: "div",
  children: void 0,
  justify: void 0,
  noWrap: false,
  spacing: void 0
};
const Inline = forwardRef(
  ({
    align,
    alignX,
    alignY,
    as,
    children,
    justify,
    noWrap,
    space,
    spacing,
    ...restProps
  }, forwardedRef) => /* @__PURE__ */ jsx(
    InlineWrapper,
    {
      as,
      "data-testid": "inline",
      ref: forwardedRef,
      $align: align,
      $alignX: alignX,
      $alignY: alignY,
      $justify: justify,
      $noWrap: noWrap,
      ...restProps,
      children: Children.map(
        children,
        (child) => child && /* @__PURE__ */ jsx(
          InlineItem,
          {
            as: as === "span" ? "span" : void 0,
            "data-testid": "inline-item",
            $space: space,
            $spacing: spacing,
            children: child
          },
          child.key
        )
      )
    }
  )
);
Inline.propTypes = propTypes;
Inline.defaultProps = defaultProps;
export {
  Inline
};
